import { render } from "./BatchNameEditDialog.vue?vue&type=template&id=0bb9671d&scoped=true"
import script from "./BatchNameEditDialog.vue?vue&type=script&lang=js"
export * from "./BatchNameEditDialog.vue?vue&type=script&lang=js"

import "./BatchNameEditDialog.vue?vue&type=style&index=0&id=0bb9671d&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb9671d"]])

export default __exports__